import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import UsaOutline from "../Map/UsaOutline";
import UsaCountyHovers from "../Map/UsaCountyHovers";
import UsaStateHovers from "../Map/UsaStateHovers";
import UsaStateBorders from "../Map/UsaStateBorders";

import HoverOver from '../HoverOver';
import HeatMapShapes from "./HeatMapShapes";

import '../Map/Map.css';
import './HeatMap.css';

class HeatMap extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 500,
      height: 250
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    this.setState({width: width, height: width * .56});
  }

  render() {
    const year = this.props.year;
    const dataProp = 'od' + String(year).substring(2);
    const self = this;

    return (
      <div ref="wrapper" className="HeatMap" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg ref="svg" width={this.state.width} height={this.state.height}>
          <UsaOutline width={this.state.width} height={this.state.height}/>
          <HeatMapShapes
            dict={this.props.dict}
            dimX={dataProp}
            width={this.state.width}
            height={this.state.height}
            onHover={hover => {
              if (hover) {
                hover.props = {dimX: dataProp, titleX: 'Overdose Rate ' + year};
              }
              self.setState({hover})
            }}
            onClick={(stateFips, countyFips) => {
              if (this.props.onClick) {
                this.props.onClick(stateFips, countyFips)
              }
            }}
          />
          <UsaStateBorders width={this.state.width} height={this.state.height}/>
          <UsaStateHovers width={this.state.width} height={this.state.height}/>
          <UsaCountyHovers width={this.state.width} height={this.state.height}/>
        </svg>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

HeatMap.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
};

export default HeatMap;


// WEBPACK FOOTER //
// ./src/charts/HeatMap/index.js